import getJourneyId from 'shared_js/helpers/trackerHelper/getJourneyId';
import getReferrer from 'shared_js/helpers/trackerHelper/getReferrer';

export default function(tracker) {
  if (!tracker || typeof tracker.event !== 'function') {
    throw new Error('error, tracker event not a function');
  }

  function trackEvent(payload) {
    tracker.event({
      journey_id: getJourneyId(),
      current_screen: payload.current_screen || '',
      params: payload.params || '',
      product_type: 'item_mitra',
      ui: window.USER && window.USER.id36,
      bl_username: window.USER && window.USER.username,
      ...payload,
    });
  }

  return {
    itemMitraLandingPageVisitTrack(payload) {
      trackEvent({
        evn: 'agenlite_vp_visit',
        referrer_url: getReferrer(),
        referrer_screen: payload.referrer_screen || '',
        customer_contact_status: payload.customer_contact_status || '',
        ...payload,
      });
    },
    itemMitraItemClickTrack(payload) {
      trackEvent({
        evn: 'agenlite_vp_product_screen_click',
        click_source: payload.click_source || '',
        click_source_status: payload.click_source_status || '',
        target_screen: payload.target_screen,
        ...payload,
      });
    },
  };
}
